import TOOL_LABEL_KEYS from '../constants/toolLabels';

import type { TAiChatToolName } from '../interfaces/IAiChatTools';

/**
 * Whether the FE knows a tool by this name.
 *
 * Checked as an own property: the name is the API's, and `constructor` is not a tool.
 */
const isAiChatToolName = (name: string): name is TAiChatToolName => (
  Object.prototype.hasOwnProperty.call(TOOL_LABEL_KEYS, name)
);

export default isAiChatToolName;
